import React from "react";
import { Tag } from "antd";

import { taskStatus } from "./const";

const StatusLabel = (props) => {
    const singelton = taskStatus.filter((item) => item.key === props.status);

    const color = singelton.length === 1 ? singelton[0].color : "#f50";

    return <Tag color={color}>{props.status}</Tag>;
};

export default StatusLabel;
